import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill';

export async function loadIntlRelativeTimeFormat(locale) {
  const unsupportedLocale = shouldPolyfill(locale);
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import(
    /* webpackChunkName: "polyfill/intl-relativetimeformat/polyfill-force" */
    '@formatjs/intl-relativetimeformat/polyfill-force'
  );
  await import(
    /* webpackChunkName: "polyfill/intl-relativetimeformat/locale-data" */
    `@formatjs/intl-relativetimeformat/locale-data/${unsupportedLocale}.js`
  );
}
